/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const File_: core.serialization.ObjectSchema<serializers.File_.Raw, Truvity.File_> = core.serialization.object({
    contentType: core.serialization.property('content_type', core.serialization.string().optional()),
    digestMultibase: core.serialization.property('digest_multibase', core.serialization.string()),
    filename: core.serialization.string(),
    filesize: core.serialization.number(),
    id: core.serialization.string(),
});

export declare namespace File_ {
    export interface Raw {
        content_type?: string | null;
        digest_multibase: string;
        filename: string;
        filesize: number;
        id: string;
    }
}
